import { type FC, type ReactNode } from 'react';
import { FileText } from 'lucide-react';
import { cn } from '../../lib/utils';

interface LlmDocumentCardLayoutProps {
  title: string;
  type?: string;
  tooltip?: string;
  actions?: ReactNode | null;
  onClick?: (() => any) | null;
}

/** Renders a card-like layout with a document icon, type, and optional configurable action btns. */
export const LlmDocumentCardLayout: FC<LlmDocumentCardLayoutProps> = ({
  title,
  type,
  tooltip,
  onClick,
  actions,
}) => (
  <div className="flex flex-row items-center gap-4 p-4 border-1 border-ring rounded-md overflow-hidden text-foreground bg-background">
    <div
      className={cn('flex-none', !!onClick && 'cursor-pointer text-devo-blue dark:text-foreground')}
      onClick={onClick ?? undefined}
      title={tooltip || title}
    >
      <FileText />
    </div>
    <div className="flex-auto">
      <p>
        <span
          className={cn(
            'font-bold',
            !!onClick && 'text-devo-blue dark:text-foreground cursor-pointer hover:underline'
          )}
          onClick={onClick ?? undefined}
          title={tooltip || title}
        >
          {title}
        </span>
      </p>
      {!!type && <p className="text-sm text-muted-foreground">{type}</p>}
    </div>
    {!!actions && <div className="flex-none">{actions}</div>}
  </div>
);
